<div class="toro-account-issue-container">
    <div class="tai-message" innerHTML="{{'STRINGS.ACCOUNT_ISSUE_MESSAGE' | translate: {accountName: accountName | translate} }}"></div>
    <div class="tai-contact-info">{{'STRINGS.PLEASE_CONTACT' | translate}} <span class="tai-help-line">{{helpLine | translate}}</span></div>
</div>
